import { render, staticRenderFns } from "./statement-import.vue?vue&type=template&id=5bc198e1&scoped=true"
import script from "./statement-import.vue?vue&type=script&lang=ts"
export * from "./statement-import.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc198e1",
  null
  
)

export default component.exports